import { FC } from "react";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ConnectWalletButton from "../ConnectWallet";
import { useNavigate } from "react-router-dom";

const MainContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "fit-content",
  padding: "5px 10px 10px 30px",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: theme.palette.background.default,
}));

const AppName = styled("h1")(({ theme }) => ({
  width: "fit-content",
  fontFamily: "Righteous",
  fontSize: "30px",
  color: theme.palette.primary.main,
  cursor: "pointer",

  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

const Navbar: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  return (
    <div className="sticky top-0 z-40 border-b border-skin-border bg-skin-bg">
      <MainContainer>
        <AppName
          onClick={() => {
            navigate("/");
          }}
        >
          {isMobile ? "DecentrAds" : "DecentrAds"}
        </AppName>
        <ConnectWalletButton />
      </MainContainer>
    </div>
  );
};
export default Navbar;
